module.exports = __webpack_public_path__ + "img/dd3.b4cf125b.jpg";